import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapLayersControlComponent } from './map-layers-control.component';
import {DxToolbarModule} from 'devextreme-angular';



@NgModule({
  declarations: [MapLayersControlComponent],
  imports: [
    CommonModule,
    DxToolbarModule
  ],
  exports: [MapLayersControlComponent]
})
export class MapLayersControlModule { }
